import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../config/firebase';
import { setLoading, setUser } from '../redux/slice/Authslice';
import { loadAdminSession } from '../utils/session';

export const useAuth = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setLoading(true));

        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                try {
                    // Role is restored from the token claim on every refresh
                    const sessionUser = await loadAdminSession(firebaseUser);
                    if (!sessionUser) {
                        // Signed in, but not an admin: never keep a session for this portal
                        await signOut(auth);
                        dispatch(setUser(null));
                    } else {
                        dispatch(setUser(sessionUser));
                    }
                } catch (error) {
                    console.error('Error restoring admin session:', error);
                    dispatch(setUser(null));
                }
            } else {
                dispatch(setUser(null));
            }

            dispatch(setLoading(false));
        }, (error) => {
            console.error('Auth state change error:', error);
            dispatch(setUser(null));
            dispatch(setLoading(false));
        });

        return () => unsubscribe();
    }, [dispatch]);
};
